import {createStore , applyMiddleware, compose, combineReducers} from 'redux'
import thunkMiddleware  from 'redux-thunk'
import warehouseReducer from './warehouse/reducers/warehouseReducer'
import entityReducder from './entity/reducers/entityReducer'
import authReducer from './auth/reducers/authReducer'
import profileReducer from './auth/reducers/profileReducer'
import vehicleReducer from './vehicles/reducers/vehicleReducer'
import employeeReducer from './employee/reducers/employeeReducer'

const combinedReducer =  combineReducers({
     auth : authReducer,
     profile : profileReducer,
     warehouse : warehouseReducer,
     entity : entityReducder,
     vehicle : vehicleReducer,
     employee : employeeReducer,
 })

const preLoadedState = {
    entity : {
        server : 'https://royalmarketing.rib.lk/api',
        entity : "ROYALMARKETING"
    }
    ,
    auth : {
        loading : false,
        error : null,
        authData : JSON.parse(window.localStorage.getItem('authData'))
    }
}
 
const store  = createStore(combinedReducer, preLoadedState, compose(applyMiddleware(thunkMiddleware)))

export default store
